import { Suspense, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { PermissionEn } from '@martech-solution/utils/constants';
import accountingPath from 'src/constants/urlPath/erp/accountingPath';
// import deliveryPath from 'src/constants/urlPath/erp/deliveryPath';
import productionPath from 'src/constants/urlPath/erp/contractExecution/productionPath';
import standardsQualityPath from 'src/constants/urlPath/erp/standardsQualityPath';
import accountingRoutes from 'src/routes/erp/accountingRoute';
import inventoryRoutes from 'src/routes/erp/inventoryRoute';
import productionRoutes from 'src/routes/erp/productionRoute';
import rndRoutes from 'src/routes/erp/rndRoute';
import type { IResourceFullAccessDetail } from 'src/types/master_data/userResource.type';
// import urlPathOld from '../constants/urlPath';
import LoadingCustom from 'src/components/v2/Loading';
import templateComponentPath from 'src/constants/urlPath/templateComponentPath';
import demoPath from 'src/constants/urlPath/demoPath';
import erpCommonRoutes from 'src/routes/erp/commonRoute';
import deliveryRoutes from 'src/routes/erp/deliveryRoute';
import installationRoutes from 'src/routes/erp/installationRoute';
import itemMasterDataRoutes from 'src/routes/erp/itemMasterDataRoute';
import planningRoutes from 'src/routes/erp/planningRoute';
import purchaseRoutes from 'src/routes/erp/purchaseRoute';
import saleRoutes from 'src/routes/erp/saleRoute';
import type { HRTicketCategoryEn } from 'src/types/master_data/hrTicketCategory.type';
import urlPath from '../constants/urlPath/urlPath';
import MainLayout from '../layouts/NewFeatures/MainLayout';
import { usePermissionNew } from './usePermission';
import accessControlRoutes from 'src/routes/erp/accessControlRoute';
import { authRoutes, errorRoutes } from '@martech-solution/utils/routes';
import { Forbidden } from '@martech-solution/utils/pages';

// const SigninOidcCallback = lazy(() => import('@martech-solution/utils/pages'));

//#region Import components
const CGButtonDemo = lazy(() => import('src/pages/Demo/CGButtonDemo'));
const TableComponentsDemo = lazy(() => import('src/pages/Demo/TableComponentsDemo'));
const ActionStackDemo = lazy(() => import('src/pages/Demo/ActionStackDemo'));

//#region Master data
// const Branch = lazy(() => import('src/pages/MasterData/Branch'));
// const DataTable = lazy(() => import('src/pages/MasterData/DataTable'));
// const AddDataTable = lazy(() => import('src/pages/MasterData/DataTable/AddDataTable'));
const Department = lazy(() => import('src/pages/HRM/Department'));
const Employee = lazy(() => import('src/pages/HRM/Employee'));
// const Position = lazy(() => import('src/pages/MasterData/Position'));
const AddEmployee = lazy(() => import('src/pages/HRM/AddEmployee'));
const EmployeeQrCode = lazy(() => import('src/pages/HRM/EmployeeQrCode'));
const EmployeeDetail = lazy(() => import('src/pages/HRM/EmployeeDetail'));
const Board = lazy(() => import('src/pages/HRM/Board'));
// const Level = lazy(() => import('src/pages/MasterData/Level'));
// const GroupUnit = lazy(() => import('src/pages/MasterData/GroupUnit'));
// const UnitOfMeasure = lazy(() => import('src/pages/MasterData/UnitOfMeasure'));
// const Tier = lazy(() => import('src/pages/MasterData/Tier'));
const JobCategory = lazy(() => import('src/pages/HRM/JobCategory'));
const AddJobCategory = lazy(() => import('src/pages/HRM/AddJobCategory'));
// const OrganizationChart = lazy(() => import('src/pages/MasterData/OrganizationChart'));
// const Asset = lazy(() => import('src/pages/MasterData/Asset'));
// const Degree = lazy(() => import('src/pages/MasterData/Degree'));
// const FieldOfBusiness = lazy(() => import('src/pages/MasterData/FieldOfBusiness'));
// const PartnerType = lazy(() => import('src/pages/MasterData/PartnerType'));
// const Partner = lazy(() => import('src/pages/MasterData/Partner'));
// const AddPartner = lazy(() => import('src/pages/MasterData/AddPartner'));
// const ContractType = lazy(() => import('src/pages/MasterData/ContractType'));
// const ApplicationInfo = lazy(() => import('src/pages/MasterData/ApplicationInfo'));
// const Certificate = lazy(() => import('src/pages/MasterData/Certificate'));
// const ErrorCode = lazy(() => import('src/pages/MasterData/ErrorCode'));
// const HRTicketCategory = lazy(() => import('src/pages/MasterData/HRTicketCategory'));
// const Resource = lazy(() => import('src/pages/MasterData/Resource'));
// const Role = lazy(() => import('src/pages/MasterData/Role'));
// const UserResource = lazy(() => import('src/pages/MasterData/UserResource'));
// const AddRole = lazy(() => import('src/pages/MasterData/AddRole'));
// const Permission = lazy(() => import('src/pages/MasterData/Permission'));
// const Holiday = lazy(() => import('src/pages/MasterData/Holiday'));
// const FuelConsumption = lazy(() => import('src/pages/MasterData/FuelConsumption'));
// const FuelUnitPrice = lazy(() => import('src/pages/MasterData/FuelUnitPrice'));
// const AdvancePaymentLimit = lazy(() => import('src/pages/Hr/AdvancePaymentLimit'));
// const SubSystem = lazy(() => import('src/pages/MasterData/SubSystem'));
// const WorkDescription = lazy(() => import('src/pages/MasterData/WorkDescription'));
// const AddSubSystem = lazy(() => import('src/pages/MasterData/AddSubSystem'));
// const AddApplicationInfo = lazy(() => import('src/pages/MasterData/AddApplicationInfo'));
// const ApplicationInfoDetail = lazy(() => import('src/pages/MasterData/ApplicationInfoDetail'));
// const Distance = lazy(() => import('src/pages/MasterData/Distance'));
// const BiometricDevice = lazy(() => import('src/pages/Hr/BiometricDevice'));
// const BiometricEmployeeMapping = lazy(() => import('src/pages/Hr/BiometricEmployeeMapping'));
// const UserTicketCategory = lazy(() => import('src/pages/MasterData/UserTicketCategory'));
// const UserJobCategory = lazy(() => import('src/pages/MasterData/UserJobCategory'));
// const Shift = lazy(() => import('src/pages/MasterData/Shift'));
// const ManagerAssignment = lazy(() => import('src/pages/MasterData/ManagerAssignment'));
// const WareHouseGroup = lazy(() => import('src/pages/MasterData/WareHouseGroup'));
// const WareHouse = lazy(() => import('src/pages/MasterData/WareHouse'));
// const MobileVersion = lazy(() => import('src/pages/MasterData/MobileVersion'));
const ProductionUnit = lazy(() => import('src/pages/HRM/ProductionUnit'));
// const AddProductionUnit = lazy(() => import('src/pages/MasterData/AddProductionUnit'));
// const QrResource = lazy(() => import('src/pages/MasterData/QrResource'));
// const AddQrResource = lazy(() => import('src/pages/MasterData/AddQrResource'));
// const AcceptancePermission = lazy(() => import('src/pages/MasterData/AcceptancePermission'));
// const Cost = lazy(() => import('src/pages/MasterData/Cost'));
// const EmployeeEvaluation = lazy(() => import('src/pages/Hr/EmployeeEvaluation'));
// const Event = lazy(() => import('src/pages/CRM/Marketing/Event'));
// const Visitor = lazy(() => import('src/pages/CRM/Marketing/Visitor'));

// factory
// const Factory = lazy(() => import('src/pages/MasterData/Factory'));
// const AddFactory = lazy(() => import('src/pages/MasterData/AddFactory'));

// productionLine
// const ProductionLine = lazy(() => import('src/pages/MasterData/ProductionLine'));
// const AddProductionLine = lazy(() => import('src/pages/MasterData/AddProductionLine'));

// binLocation
// const BinLocation = lazy(() => import('src/pages/MasterData/BinLocation'));
// const AddBinLocation = lazy(() => import('src/pages/MasterData/BinLocation/AddBinLocation'));
// const BinLocationQrCode = lazy(() => import('src/pages/MasterData/BinLocation/BinLocationQrCode'));

// technicianType
// const TechnicianType = lazy(() => import('src/pages/MasterData/TechnicianType'));
// const AddTechnicianType = lazy(() => import('src/pages/MasterData/TechnicianType/AddTechnicianType'));

// technician
// const Technician = lazy(() => import('src/pages/MasterData/Technician'));
// const AddTechnician = lazy(() => import('src/pages/MasterData/Technician/AddTechnician'));

//#endregion

//#region HR
// const EmployeeShift = lazy(() => import('src/pages/Hr/EmployeeShift'));
// const AdvancePaymentEmployee = lazy(() => import('src/pages/Hr/AdvancePaymentEmployee'));
// const LeaveTicketPackage = lazy(() => import('src/pages/Hr/LeaveTicketPackage'));
// const AddLeaveTicketPackage = lazy(() => import('src/pages/Hr/AddLeaveTicketPackage'));
// const LeaveTicketPackageDetail = lazy(() => import('src/pages/Hr/LeaveTicketPackageDetail'));
// const AdditionalWorkingTimePackage = lazy(() => import('src/pages/Hr/AdditionalWorkingTimePackage'));
// const AdditionalWorkingTimePackageDetail = lazy(() => import('src/pages/Hr/AdditionalWorkingTimePackageDetail'));
// const EmployeeCompensation = lazy(() => import('src/pages/Hr/EmployeeCompensation'));
//#endregion

//#region Import components V2
// const HomeV2 = lazy(() => import('src/pages/v2/Home'));
// const HomeSub = lazy(() => import('src/pages/v2/HomeSub'));
// const BiometricLogV2 = lazy(() => import('src/pages/v2/HrTicket/BiometricLog'));

// #region Ticket
// const TicketManagement = lazy(() => import('src/pages/v2/TicketManagement'));
// const TicketsV2 = lazy(() => import('src/pages/v2/Ticket/Tickets'));
// const TicketLayout = lazy(() => import('src/layouts/v2/TicketLayout'));
// const SubLayout = lazy(() => import('src/layouts/v2/ExternalLayout'));
// const AddTicketV2 = lazy(() => import('src/pages/v2/Ticket/AddTicket'));
// const TicketDetailSolutionAddV2 = lazy(
//   () => import('src/pages/v2/Ticket/TicketDetail/TicketDetailSolution/TicketDetailSolutionAdd')
// );
//#endregion

// #region HR
// const AdvancePaymentTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AdvancePaymentTicket'));
// const AddAdvancePaymentTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AddAdvancePaymentTicket'));

// const TransportationTicketV2 = lazy(() => import('src/pages/v2/HrTicket/TransportationTicket'));
// const AddTransportationTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AddTransportationTicket'));

// const LeaveTicketV2 = lazy(() => import('src/pages/v2/HrTicket/LeaveTicket'));
// const LeaveTicketPackageV2 = lazy(() => import('src/pages/v2/HrTicket/LeaveTicketPackage'));
// const AddLeaveTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AddLeaveTicket'));
// const AddLeaveTicketSub = lazy(() => import('src/pages/v2/Sub/AddLeaveTicket'));

// const ExternalWorkerTicket = lazy(() => import('src/pages/v2/HrTicket/ExternalWorkerTicket'));
// const AddExternalWorkerTicket = lazy(() => import('src/pages/v2/HrTicket/AddExternalWorkerTicket'));

// const ExpenseTrackingRequestTicket = lazy(() => import('src/pages/v2/HrTicket/ExpenseTrackingRequestTicket'));
// const AddExpenseTrackingRequestTicket = lazy(() => import('src/pages/v2/HrTicket/AddExpenseTrackingRequestTicket'));
// const ExpenseTrackingRequestTicketHrConfirm = lazy(() => import('src/pages/v2/HrConfirm/ExpenseTrackingRequestTicket'));
// const OvertimeTicketV2 = lazy(() => import('src/pages/v2/HrTicket/OvertimeTicket'));
// const AddOvertimeTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AddOvertimeTicket'));

// const HandoverTicketV2 = lazy(() => import('src/pages/v2/OfficeTicket/HandoverTicket'));
// const AddHandoverTicketV2 = lazy(() => import('src/pages/v2/OfficeTicket/AddHandoverTicket'));

// const BusinessTripTicketV2 = lazy(() => import('src/pages/v2/HrTicket/BusinessTripTicket'));
// const AddBusinessTripTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AddBusinessTripTicket'));

// const PurchaseRequestTicketV2 = lazy(() => import('src/pages/v2/HrTicket/PurchaseRequestTicket'));
// const AddPurchaseRequestTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AddPurchaseRequestTicket'));

// const EquipmentSupplyRequestTicketV2 = lazy(() => import('src/pages/v2/HrTicket/EquipmentSupplyRequestTicket'));
// const AddEquipmentSupplyRequestTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AddEquipmentSupplyRequestTicket'));

// const AdditionalWorkingTimeTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AdditionalWorkingTimeTicket'));
// const AddAdditionalWorkingTimeTicketV2 = lazy(() => import('src/pages/v2/HrTicket/AddAdditionalWorkingTimeTicket'));

// const AdditionalWorkingTimePackageV2 = lazy(() => import('src/pages/v2/HrTicket/AdditionalWorkingTimePackage'));

// const LeaveTicketHrConfirmV2 = lazy(() => import('src/pages/v2/HrConfirm/LeaveTicket'));
// const BusinessTripHrConfirmV2 = lazy(() => import('src/pages/v2/HrConfirm/BusinessTripTicket'));
// const OvertimeHrConfirmV2 = lazy(() => import('src/pages/v2/HrConfirm/OvertimeTicket'));
// const TransportationHrConfirmV2 = lazy(() => import('src/pages/v2/HrConfirm/TransportationTicket'));
//#endregion

//#region V2 USER GUIDE
// const UserGuides = lazy(() => import('src/pages/v2/UserGuide/UserGuides'));
//#endregion V2 USER GUIDE

//#region V2 LEAVE REMAINING YEAR
// const LeaveRemainingYear = lazy(() => import('src/pages/v2/HrTicket/LeaveRemainingYear'));
//#endregion V2 LEAVE REMAINING YEAR

//#region TOPIC
// const TopicLayout = lazy(() => import('src/layouts/v2/TopicLayout'));
// const TopicConversationBox = lazy(() => import('src/pages/v2/Topic/TopicConversationBox'));
//#endregion TOPIC

//#region REPORT
// const ReportLayout = lazy(() => import('src/layouts/v2/ReportLayout'));
// const ReportManagement = lazy(() => import('src/pages/v2/Report/ReportManagement'));
// const ReportLeaveTicket = lazy(() => import('src/pages/v2/Report/LeaveTicket'));
// const ReportOvertimeTicket = lazy(() => import('src/pages/v2/Report/OvertimeTicket'));
// const PNL04 = lazy(() => import('src/pages/v2/Report/PNL04'));
// const ReportBusinessTripTicket = lazy(() => import('src/pages/v2/Report/BusinessTripTicket'));
// const ReportDailyInventoryJournal = lazy(() => import('src/pages/v2/Report/DailyInventoryJournal'));
//#endregion REPORT

// //#region ITEM MASTER DATA
// const ItemMasterDataHome = lazy(() => import('src/pages/ERP/ItemMasterData'));
// const ItemMasterData = lazy(() => import('src/pages/ERP/ItemMasterData/ItemMasterData'));
// const AddItemMasterData = lazy(() => import('src/pages/ERP/ItemMasterData/AddItemMasterData'));
// const ItemType = lazy(() => import('src/pages/ERP/ItemMasterData/ItemType'));
// const AddItemType = lazy(() => import('src/pages/ERP/ItemMasterData/AddItemType'));
// const ItemTypeDetail = lazy(() => import('src/pages/ERP/ItemMasterData/ItemTypeDetail'));
// const ItemGroup = lazy(() => import('src/pages/ERP/ItemMasterData/ItemGroup'));
// const AddItemGroup = lazy(() => import('src/pages/ERP/ItemMasterData/AddItemGroup'));
// const ItemGroupDetail = lazy(() => import('src/pages/ERP/ItemMasterData/ItemGroupDetail'));
// const Model = lazy(() => import('src/pages/ERP/ItemMasterData/Model'));
// const AddModel = lazy(() => import('src/pages/ERP/ItemMasterData/AddModel'));
// const ModelDetail = lazy(() => import('src/pages/ERP/ItemMasterData/ModelDetail'));
// const ItemSpec = lazy(() => import('src/pages/ERP/ItemMasterData/ItemSpec'));
// const AddItemSpec = lazy(() => import('src/pages/ERP/ItemMasterData/AddItemSpec'));
// const ItemSpecDetail = lazy(() => import('src/pages/ERP/ItemMasterData/ItemSpecDetail'));
// const AccountingItem = lazy(() => import('src/pages/ERP/ItemMasterData/AccountingItem'));
// const Specification = lazy(() => import('src/pages/ERP/ItemMasterData/Specification'));
// const ItemTechnicalSpecification = lazy(() => import('src/pages/ERP/ItemMasterData/ItemTechnicalSpecification'));
// const DimensionalStandard = lazy(() => import('src/pages/ERP/ItemMasterData/DimensionalStandard'));
// const AccountingAccountType = lazy(() => import('src/pages/MasterData/AccountingAccountType'));
// const AccountingObjectType = lazy(() => import('src/pages/MasterData/AccountingObjectType'));
const GeneralAccountingAccount = lazy(() => import('src/pages/HRM/GeneralAccountingAccount'));
// const Process = lazy(() => import('src/pages/ERP/ItemMasterData/Process'));
// const AddProcess = lazy(() => import('src/pages/ERP/ItemMasterData/AddProcess'));
// const ContractualUnitPrice = lazy(() => import('src/pages/ERP/ItemMasterData/ContractualUnitPrice'));
// // const ContractualUnitPriceForm = lazy(() => import('src/pages/ERP/ItemMasterData/ContractualUnitPriceForm'));
// //#endregion ITEM MASTER DATA

//#region CONTRACT EXECUTION
const ContractExecution = lazy(() => import('src/pages/ERP/ContractExecution'));

//#region PRODUCTION MANAGEMENT

const PackagingRequest = lazy(() => import('src/pages/ERP/ContractExecution/Production/PackagingRequest'));
const AddPackagingRequest = lazy(
  () => import('src/pages/ERP/ContractExecution/Production/PackagingRequest/AddPackagingRequest')
);

const DeliveryRequest = lazy(() => import('src/pages/ERP/ContractExecution/Production/DeliveryRequest'));
const AddDeliveryRequest = lazy(
  () => import('src/pages/ERP/ContractExecution/Production/DeliveryRequest/AddDeliveryRequest')
);

const DeliveryOrder = lazy(() => import('src/pages/ERP/ContractExecution/Production/DeliveryOrder'));
const AddDeliveryOrder = lazy(
  () => import('src/pages/ERP/ContractExecution/Production/DeliveryOrder/AddDeliveryOrder')
);

const RawMatEst = lazy(() => import('src/pages/ERP/ContractExecution/Production/RawMatEst'));
const AddRawMatEst = lazy(() => import('src/pages/ERP/ContractExecution/Production/RawMatEst/AddRawMatEst'));

//#endregion PRODUCTION MANAGEMENT

//#region INSTALLATION REQUEST
const InstallationOrder = lazy(() => import('src/pages/ERP/ContractExecution/Installation/InstallationOrder'));
const InstallationRequest = lazy(() => import('src/pages/ERP/ContractExecution/Installation/InstallationRequest'));
const WarehouseTransferRequest = lazy(
  () => import('src/pages/ERP/ContractExecution/Installation/WarehouseTransferRequest')
);
const InstallationBudgetPlan = lazy(
  () => import('src/pages/ERP/ContractExecution/Installation/InstallationBudgetPlan')
);
const InstallationProcess = lazy(() => import('src/pages/ERP/ContractExecution/Installation/InstallationProcess'));
const QualityControl = lazy(() => import('src/pages/ERP/ContractExecution/Installation/QualityControl'));
//#endregion INSTALLATION REQUEST
//#endregion CONTRACT EXECUTION

//#region FINANCE
const Finance = lazy(() => import('src/pages/ERP/Finance'));
const CashFlowPlan = lazy(() => import('src/pages/ERP/Finance/CashFlowPlan'));
const FinanceReport = lazy(() => import('src/pages/ERP/Finance/FinanceReport'));
const PaymentPlan = lazy(() => import('src/pages/ERP/Finance/PaymentPlan'));
const CashFlowReport = lazy(() => import('src/pages/ERP/Finance/CashFlowReport'));
//#endregion FINANCE

//#region ACCOUNTING

const Accounting = lazy(() => import('src/pages/ERP/Accounting'));
const PaymentRequestTicket = lazy(() => import('src/pages/ERP/Accounting/PaymentRequestTicket'));

//#endregion ACCOUNTING

//#region RECRUITMENT
const Candidate = lazy(() => import('src/pages/ERP/HumanResource/RecruitmentManagement/Candidate'));
const EmploymentConfirmationNotice = lazy(
  () => import('src/pages/ERP/HumanResource/RecruitmentManagement/EmploymentConfirmationNotice')
);
const InterviewInvitationLetter = lazy(
  () => import('src/pages/ERP/HumanResource/RecruitmentManagement/InterviewInvitationLetter')
);
const JobOfferLetter = lazy(() => import('src/pages/ERP/HumanResource/RecruitmentManagement/JobOfferLetter'));
const JobRequirement = lazy(() => import('src/pages/ERP/HumanResource/RecruitmentManagement/JobRequirement'));
const RecruitmentActivityResults = lazy(
  () => import('src/pages/ERP/HumanResource/RecruitmentManagement/RecruitmentActivityResults')
);
const RecruitmentPlan = lazy(() => import('src/pages/ERP/HumanResource/RecruitmentManagement/RecruitmentPlan'));
const RecruitmentProcess = lazy(() => import('src/pages/ERP/HumanResource/RecruitmentManagement/RecruitmentProcess'));
const ResultNotificationLetter = lazy(
  () => import('src/pages/ERP/HumanResource/RecruitmentManagement/ResultNotificationLetter')
);
//#endregion RECRUITMENT

//#region TRAINING
const TrainingActivityResult = lazy(
  () => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingActivityResult')
);
const TrainingCost = lazy(() => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingCost'));
const TrainingDocumentation = lazy(
  () => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingDocumentation')
);
const TrainingInvitationLetter = lazy(
  () => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingInvitationLetter')
);
const TrainingParticipant = lazy(() => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingParticipant'));
const TrainingPlan = lazy(() => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingPlan'));
const TrainingProcess = lazy(() => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingProcess'));
const TrainingProgram = lazy(() => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingProgram'));
const TrainingRequirement = lazy(() => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingRequirement'));
const TrainingResult = lazy(() => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingResult'));
const TrainingResultNotification = lazy(
  () => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingResultNotification')
);
const TrainingSupplier = lazy(() => import('src/pages/ERP/HumanResource/TrainingManagement/TrainingSupplier'));
//#endregion TRAINING

//#region Human Resource
const HumanResource = lazy(() => import('src/pages/ERP/HumanResource'));
const CnbJobDescription = lazy(() => import('src/pages/ERP/HumanResource/CnbManagement/JobDescription'));
//#endregion Human Resource

//#region  STANDARDS QUALITY
const StandardQuality = lazy(() => import('src/pages/ERP/StandardsQuality'));
const ProductionPlan = lazy(() => import('src/pages/ERP/StandardsQuality/ProductionPlan'));
const QcTemplate = lazy(() => import('src/pages/ERP/StandardsQuality/QcTemplate'));
const AddQcTemplate = lazy(() => import('src/pages/ERP/StandardsQuality/AddQcTemplate'));
const QcCheck = lazy(() => import('src/pages/ERP/StandardsQuality/QcCheck'));
const AddQcCheck = lazy(() => import('src/pages/ERP/StandardsQuality/AddQcCheck'));
const AddProductionPlan = lazy(() => import('src/pages/ERP/StandardsQuality/AddProductionPlan'));
const ProductionPlanDetail = lazy(() => import('src/pages/ERP/StandardsQuality/ProductionPlanDetail'));
const Standard = lazy(() => import('src/pages/ERP/StandardsQuality/Standard'));
const CheckList = lazy(() => import('src/pages/ERP/StandardsQuality/CheckList'));
const CertificationAssessmentPlan = lazy(() => import('src/pages/ERP/StandardsQuality/CertificationAssessmentPlan'));
const QualityInspectionRequirement = lazy(() => import('src/pages/ERP/StandardsQuality/QualityInspectionRequirement'));
const QualityControlProcess = lazy(() => import('src/pages/ERP/StandardsQuality/QualityControlProcess'));
const MaterialQualityManagement = lazy(() => import('src/pages/ERP/StandardsQuality/MaterialQualityManagement'));
const ProductionProcess = lazy(() => import('src/pages/Rnd/ProductionProcess'));
const QcResult = lazy(() => import('src/pages/ERP/StandardsQuality/QcResult'));
const QcResultDetail = lazy(() => import('src/pages/ERP/StandardsQuality/QcResult/QcResultDetail'));

//#endregion STANDARDS QUALITYimport ProductionRequestDetail from './../pages/ContractExecution/Production/ProductionRequest/ProductionRequestDetail/index';

export interface RouteType {
  path: string;
  redirect?: string;
  Layout?: any;
  SubLayout?: any;
  Component?: any;
  permission?: PermissionEn;
  checkPath?: string;
  isUsePathV2?: boolean;
  hasSidebar?: boolean;
  hasSubSidebar?: boolean;
  hasSubHeader?: boolean;
  isHideDetailLayout?: boolean;
  isDisableFooter?: boolean;
  ticketCategoryCode?: HRTicketCategoryEn; // này mới thêm sau để dùng cho bên ERP
}

const routesV2: RouteType[] = [
  //#region HRM
  {
    path: urlPath.hrm.location,
    Layout: MainLayout,
    Component: HumanResource
  },

  //#region C&B
  {
    path: urlPath.cnbEmployee.location,
    Layout: MainLayout,
    Component: Employee,
    checkPath: urlPath.cnbEmployee.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.cnbEmployeeAdd.location,
    Layout: MainLayout,

    Component: AddEmployee,
    checkPath: urlPath.cnbEmployee.location,
    permission: PermissionEn.create
  },
  {
    path: urlPath.cnbEmployeeQR.location,
    Layout: MainLayout,
    Component: EmployeeQrCode,
    checkPath: urlPath.cnbEmployee.location,
    permission: PermissionEn.get_qr
  },
  {
    path: `${urlPath.cnbEmployeeEdit.location}/:id`,
    Layout: MainLayout,

    Component: AddEmployee,
    checkPath: urlPath.cnbEmployee.location,
    permission: PermissionEn.update
  },
  {
    path: `${urlPath.cnbEmployeeDetail.location}/:id`,
    Layout: MainLayout,
    Component: EmployeeDetail,
    checkPath: urlPath.cnbEmployee.location,
    permission: PermissionEn.viewDetail
  },
  {
    path: urlPath.cnbProductionUnit.location,
    Layout: MainLayout,
    Component: ProductionUnit,
    checkPath: urlPath.cnbProductionUnit.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.cnbBoard.location,
    Layout: MainLayout,
    Component: Board,
    checkPath: urlPath.cnbBoard.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.cnbDepartment.location,
    Layout: MainLayout,
    Component: Department,
    checkPath: urlPath.cnbDepartment.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.cnbDepartment.location,
    Layout: MainLayout,
    Component: Department,
    checkPath: urlPath.cnbDepartment.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.cnbJobCategory.location,
    Layout: MainLayout,
    Component: JobCategory,
    checkPath: urlPath.cnbJobCategory.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.cnbJobCategoryAdd.location,
    Layout: MainLayout,

    Component: AddJobCategory,
    checkPath: urlPath.cnbJobCategory.location,
    permission: PermissionEn.create
  },
  {
    path: `${urlPath.cnbJobCategoryEdit.location}/:id`,
    Layout: MainLayout,

    Component: AddJobCategory,
    checkPath: urlPath.cnbJobCategory.location,
    permission: PermissionEn.update
  },
  {
    path: urlPath.recruitmentJobDescription.location,
    Layout: MainLayout,
    Component: CnbJobDescription,
    checkPath: urlPath.recruitmentJobDescription.location,
    permission: PermissionEn.read
  },
  //#endregion C&B

  //#region RECRUITMENT
  {
    path: urlPath.recruitmentProcess.location,
    Layout: MainLayout,
    Component: RecruitmentProcess,
    checkPath: urlPath.recruitmentProcess.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.recruitmentJobDescription.location,
    Layout: MainLayout,
    Component: CnbJobDescription,
    checkPath: urlPath.recruitmentJobDescription.location,
    permission: PermissionEn.read
  },

  {
    path: urlPath.recruitmentPlan.location,
    Layout: MainLayout,
    Component: RecruitmentPlan,
    checkPath: urlPath.recruitmentPlan.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.jobRequirements.location,
    Layout: MainLayout,
    Component: JobRequirement,
    checkPath: urlPath.jobRequirements.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.recruitmentCandidate.location,
    Layout: MainLayout,
    Component: Candidate,
    checkPath: urlPath.recruitmentCandidate.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.interviewInvitationLetter.location,
    Layout: MainLayout,
    Component: InterviewInvitationLetter
  },
  {
    path: urlPath.resultNotificationLetter.location,
    Layout: MainLayout,
    Component: ResultNotificationLetter,
    checkPath: urlPath.resultNotificationLetter.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.jobOfferLetter.location,
    Layout: MainLayout,
    Component: JobOfferLetter,
    checkPath: urlPath.jobOfferLetter.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.employmentConfirmationNotice.location,
    Layout: MainLayout,
    Component: EmploymentConfirmationNotice,
    checkPath: urlPath.employmentConfirmationNotice.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.recruitmentActivityResults.location,
    Layout: MainLayout,
    Component: RecruitmentActivityResults,
    checkPath: urlPath.recruitmentActivityResults.location,
    permission: PermissionEn.read
  },
  //#endregion RECRUITMENT

  //#region TRAINING
  {
    path: urlPath.trainingProcess.location,
    Layout: MainLayout,
    Component: TrainingProcess,
    checkPath: urlPath.trainingProcess.location,
    permission: PermissionEn.read
  },

  {
    path: urlPath.trainingDocumentation.location,
    Layout: MainLayout,
    Component: TrainingDocumentation,
    checkPath: urlPath.trainingDocumentation.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingJobDescription.location,
    Layout: MainLayout,
    Component: CnbJobDescription,
    checkPath: urlPath.trainingJobDescription.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingPlan.location,
    Layout: MainLayout,
    Component: TrainingPlan,
    checkPath: urlPath.trainingPlan.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingRequirements.location,
    Layout: MainLayout,
    Component: TrainingRequirement,
    checkPath: urlPath.trainingRequirements.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingSupplier.location,
    Layout: MainLayout,
    Component: TrainingSupplier,
    checkPath: urlPath.trainingSupplier.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingProgram.location,
    Layout: MainLayout,
    Component: TrainingProgram,
    checkPath: urlPath.trainingProgram.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingCost.location,
    Layout: MainLayout,
    Component: TrainingCost,
    checkPath: urlPath.trainingCost.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingParticipant.location,
    Layout: MainLayout,
    Component: TrainingParticipant,
    checkPath: urlPath.trainingParticipant.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingInvitationLetter.location,
    Layout: MainLayout,
    Component: TrainingInvitationLetter,
    checkPath: urlPath.trainingInvitationLetter.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingResult.location,
    Layout: MainLayout,
    Component: TrainingResult,
    checkPath: urlPath.trainingResult.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingResultNotification.location,
    Layout: MainLayout,
    Component: TrainingResultNotification,
    checkPath: urlPath.trainingResultNotification.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.trainingActivityResults.location,
    Layout: MainLayout,
    Component: TrainingActivityResult,
    checkPath: urlPath.trainingActivityResults.location,
    permission: PermissionEn.read
  },
  //#endregion TRAINING

  //#region STANDARDS QUALITY
  {
    path: standardsQualityPath.standardsQuality,
    Layout: MainLayout,
    Component: StandardQuality
  },
  {
    path: standardsQualityPath.qcTemplate,
    Layout: MainLayout,
    Component: QcTemplate,
    checkPath: standardsQualityPath.qcTemplate,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.qcTemplateAdd,
    Layout: MainLayout,
    Component: AddQcTemplate,
    checkPath: standardsQualityPath.qcTemplate,
    permission: PermissionEn.create
  },
  {
    path: `${standardsQualityPath.qcTemplateEdit}/:id`,
    Layout: MainLayout,
    Component: AddQcTemplate,
    checkPath: standardsQualityPath.qcTemplate,
    permission: PermissionEn.update
  },
  {
    path: `${standardsQualityPath.qcTemplateDetail}/:id`,
    Layout: MainLayout,
    Component: AddQcTemplate,
    checkPath: standardsQualityPath.qcTemplate,
    permission: PermissionEn.viewDetail
  },
  {
    path: standardsQualityPath.qcCheck,
    Layout: MainLayout,
    Component: QcCheck,
    checkPath: standardsQualityPath.qcCheck,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.qcCheckAdd,
    Layout: MainLayout,
    Component: AddQcCheck,
    checkPath: standardsQualityPath.qcCheck,
    permission: PermissionEn.create
  },
  {
    path: `${standardsQualityPath.qcCheckEdit}/:id`,
    Layout: MainLayout,
    Component: AddQcCheck,
    checkPath: standardsQualityPath.qcCheck,
    permission: PermissionEn.update
  },
  {
    path: `${standardsQualityPath.qcCheckDetail}/:id`,
    Layout: MainLayout,
    Component: AddQcCheck,
    checkPath: standardsQualityPath.qcCheck,
    permission: PermissionEn.viewDetail
  },
  {
    path: standardsQualityPath.productionPlan,
    Layout: MainLayout,
    Component: ProductionPlan,
    checkPath: standardsQualityPath.productionPlan,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.productionPlanAdd,
    Layout: MainLayout,
    Component: AddProductionPlan,
    checkPath: standardsQualityPath.productionPlan,
    permission: PermissionEn.create
  },
  {
    path: `${standardsQualityPath.productionPlanEdit}/:id`,
    Layout: MainLayout,
    Component: AddProductionPlan,
    checkPath: standardsQualityPath.productionPlan,
    permission: PermissionEn.update
  },
  {
    path: `${standardsQualityPath.productionPlanDetail}/:id`,
    Layout: MainLayout,
    Component: ProductionPlanDetail,
    checkPath: standardsQualityPath.productionPlan,
    permission: PermissionEn.viewDetail
  },
  {
    path: standardsQualityPath.standard,
    Layout: MainLayout,
    Component: Standard,
    checkPath: standardsQualityPath.standard,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.checkList,
    Layout: MainLayout,
    Component: CheckList,
    checkPath: standardsQualityPath.checkList,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.certificationAssessmentPlan,
    Layout: MainLayout,
    Component: CertificationAssessmentPlan,
    checkPath: standardsQualityPath.certificationAssessmentPlan,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.qualityInspectionRequirement,
    Layout: MainLayout,
    Component: QualityInspectionRequirement,
    checkPath: standardsQualityPath.qualityInspectionRequirement,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.qualityControlProcess,
    Layout: MainLayout,
    Component: QualityControlProcess,
    checkPath: standardsQualityPath.qualityControlProcess,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.materialQualityManagement,
    Layout: MainLayout,
    Component: MaterialQualityManagement,
    checkPath: standardsQualityPath.materialQualityManagement,
    permission: PermissionEn.read
  },
  {
    path: standardsQualityPath.qcResult,
    Layout: MainLayout,
    Component: QcResult,
    checkPath: standardsQualityPath.qcResult,
    permission: PermissionEn.read
  },
  {
    path: `${standardsQualityPath.qcResultDetail}/:id`,
    Layout: MainLayout,
    checkPath: standardsQualityPath.qcResult,
    Component: QcResultDetail,
    permission: PermissionEn.viewDetail
  },
  //#endregion STANDARDS QUALITY

  //#region PRODUCTION

  // DELIVERY ORDER
  {
    path: productionPath.deliveryOrder,
    Layout: MainLayout,
    Component: DeliveryOrder,
    checkPath: productionPath.deliveryOrder,
    permission: PermissionEn.read
  },
  {
    path: productionPath.deliveryOrderAdd,
    Layout: MainLayout,

    Component: AddDeliveryOrder,
    checkPath: productionPath.deliveryOrder,
    permission: PermissionEn.create
  },
  {
    path: `${productionPath.deliveryOrderEdit}/:id`,
    Layout: MainLayout,

    Component: AddDeliveryOrder,
    checkPath: productionPath.deliveryOrder,
    permission: PermissionEn.update
  },
  // Raw Matterial Estimate
  {
    path: urlPath.rawMatEst.location,
    Layout: MainLayout,
    Component: RawMatEst,
    checkPath: urlPath.rawMatEst.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.rawMatEstAdd.location,
    Layout: MainLayout,

    Component: AddRawMatEst,
    checkPath: urlPath.rawMatEst.location,
    permission: PermissionEn.create
  },
  {
    path: `${urlPath.rawMatEstEdit.location}/:id`,
    Layout: MainLayout,

    Component: AddRawMatEst,
    checkPath: urlPath.rawMatEst.location,
    permission: PermissionEn.update
  },
  // DELIVERY REQUEST
  {
    path: productionPath.deliveryRequest,
    Layout: MainLayout,
    Component: DeliveryRequest,
    checkPath: productionPath.deliveryRequest,
    permission: PermissionEn.read
  },
  {
    path: productionPath.deliveryRequestAdd,
    Layout: MainLayout,

    Component: AddDeliveryRequest,
    checkPath: productionPath.deliveryRequest,
    permission: PermissionEn.create
  },
  {
    path: `${productionPath.deliveryRequestEdit}/:id`,
    Layout: MainLayout,

    Component: AddDeliveryRequest,
    checkPath: productionPath.deliveryRequest,
    permission: PermissionEn.update
  },
  // PACKAGING REQUEST
  {
    path: urlPath.packagingRequest.location,
    Layout: MainLayout,
    Component: PackagingRequest,
    checkPath: urlPath.packagingRequest.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.packagingRequestAdd.location,
    Layout: MainLayout,

    Component: AddPackagingRequest,
    checkPath: urlPath.packagingRequest.location,
    permission: PermissionEn.create
  },
  {
    path: `${urlPath.packagingRequestEdit.location}/:id`,
    Layout: MainLayout,

    Component: AddPackagingRequest,
    checkPath: urlPath.packagingRequest.location,
    permission: PermissionEn.update
  },
  // BUDGET PLAN
  {
    path: urlPath.productionBudgetPlan.location,
    Layout: MainLayout,
    Component: InstallationBudgetPlan,
    checkPath: urlPath.productionBudgetPlan.location,
    permission: PermissionEn.read
  },
  // PROCESS
  {
    path: urlPath.productionProcess.location,
    Layout: MainLayout,
    Component: ProductionProcess,
    checkPath: urlPath.productionProcess.location,
    permission: PermissionEn.read
  },
  // PROCESS
  {
    path: urlPath.productionQualityControl.location,
    Layout: MainLayout,
    Component: QualityControl,
    checkPath: urlPath.productionQualityControl.location,
    permission: PermissionEn.read
  },

  //#endregion PRODUCTION

  //#region FINANCE
  {
    path: urlPath.finance.location,
    Layout: MainLayout,
    Component: Finance
  },
  {
    path: urlPath.cashFlowPlan.location,
    Layout: MainLayout,
    Component: CashFlowPlan,
    checkPath: urlPath.cashFlowPlan.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.financeReport.location,
    Layout: MainLayout,
    Component: FinanceReport,
    checkPath: urlPath.financeReport.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.paymentPlan.location,
    Layout: MainLayout,
    Component: PaymentPlan,
    checkPath: urlPath.paymentPlan.location,
    permission: PermissionEn.read
  },
  {
    path: urlPath.cashFlowReport.location,
    Layout: MainLayout,
    Component: CashFlowReport,
    checkPath: urlPath.cashFlowReport.location,
    permission: PermissionEn.read
  },
  //#endregion FINANCE

  //#region ACCOUNTING
  {
    path: accountingPath.accounting,
    Layout: MainLayout,
    Component: Accounting
  },

  {
    path: accountingPath.accountingAccount,
    Layout: MainLayout,
    Component: GeneralAccountingAccount,
    permission: PermissionEn.read
  },

  {
    path: accountingPath.accountingPaymentRequestTicket,
    Layout: MainLayout,
    Component: PaymentRequestTicket,
    checkPath: accountingPath.accountingAccount,
    permission: PermissionEn.read
  },

  //#endregion ACCOUNTING

  //#region  CONTRACT EXECUTION
  {
    path: urlPath.contractExecution.location,
    Layout: MainLayout,
    Component: ContractExecution
  },
  //#region installation
  //INSTALLATION ORDER
  {
    path: urlPath.installationOrder.location,
    Layout: MainLayout,
    Component: InstallationOrder,
    checkPath: urlPath.installationOrder.location,
    permission: PermissionEn.read
  },
  //INSTALLATION DELIVERY REQUEST
  {
    path: urlPath.installationDeliveryOrder.location,
    Layout: MainLayout,
    Component: DeliveryOrder,
    checkPath: urlPath.installationDeliveryOrder.location,
    permission: PermissionEn.read
  },
  //WAREHOUSE TRANSFER REQUEST
  {
    path: urlPath.installationWareHouseTransferRequest.location,
    Layout: MainLayout,
    Component: WarehouseTransferRequest,
    checkPath: urlPath.installationWareHouseTransferRequest.location,
    permission: PermissionEn.read
  },
  //INSTALLATION BUDGET PLANNING
  {
    path: urlPath.installationBudgetPlan.location,
    Layout: MainLayout,
    Component: InstallationBudgetPlan,
    checkPath: urlPath.installationBudgetPlan.location,
    permission: PermissionEn.read
  },
  //INSTALLATION PROCESS
  {
    path: urlPath.installationProcess.location,
    Layout: MainLayout,
    Component: InstallationProcess,
    checkPath: urlPath.installationProcess.location,
    permission: PermissionEn.read
  },
  //INSTALLATION QUALITY CONTROL
  {
    path: urlPath.installationQualityControl.location,
    Layout: MainLayout,
    Component: QualityControl,
    checkPath: urlPath.installationQualityControl.location,
    permission: PermissionEn.read
  },
  //#endregion installation

  //#region maintenance
  //MAINTENANCE ORDER
  {
    path: urlPath.maintenanceOrder.location,
    Layout: MainLayout,
    Component: InstallationOrder,
    checkPath: urlPath.maintenanceOrder.location,
    permission: PermissionEn.read
  },
  //MAINTENANCE DELIVERY REQUEST
  {
    path: urlPath.maintenanceDeliveryOrder.location,
    Layout: MainLayout,
    Component: DeliveryOrder,
    checkPath: urlPath.maintenanceDeliveryOrder.location,
    permission: PermissionEn.read
  },
  //MAINTENANCE REQUEST
  {
    path: urlPath.maintenanceRequest.location,
    Layout: MainLayout,
    Component: InstallationRequest,
    checkPath: urlPath.maintenanceRequest.location,
    permission: PermissionEn.read
  },
  //WAREHOUSE TRANSFER REQUEST
  {
    path: urlPath.maintenanceWareHouseTransferRequest.location,
    Layout: MainLayout,
    Component: WarehouseTransferRequest,
    checkPath: urlPath.maintenanceWareHouseTransferRequest.location,
    permission: PermissionEn.read
  },
  //MAINTENANCE BUDGET PLANNING
  {
    path: urlPath.maintenanceBudgetPlan.location,
    Layout: MainLayout,
    Component: InstallationBudgetPlan,
    checkPath: urlPath.maintenanceBudgetPlan.location,
    permission: PermissionEn.read
  },
  //MAINTENANCE PROCESS
  {
    path: urlPath.maintenanceProcess.location,
    Layout: MainLayout,
    Component: InstallationProcess,
    checkPath: urlPath.maintenanceProcess.location,
    permission: PermissionEn.read
  },
  //MAINTENANCE QUALITY CONTROL
  {
    path: urlPath.maintenanceQualityControl.location,
    Layout: MainLayout,
    Component: QualityControl,
    checkPath: urlPath.maintenanceQualityControl.location,
    permission: PermissionEn.read
  },
  //#endregion maintenance

  //#endregion CONTRACT EXECUTION

  ...accountingRoutes,
  ...inventoryRoutes,
  ...rndRoutes,
  ...productionRoutes,
  ...planningRoutes,
  ...saleRoutes,
  ...itemMasterDataRoutes,
  ...deliveryRoutes,
  ...installationRoutes,
  ...purchaseRoutes,
  ...erpCommonRoutes,
  ...accessControlRoutes
];

const commonRoutes: RouteType[] = [
  {
    path: templateComponentPath,
    Layout: MainLayout,
    Component: CGButtonDemo
  },
  {
    path: demoPath.tableComponents,
    Layout: MainLayout,
    Component: TableComponentsDemo
  },
  {
    path: demoPath.actionStack,
    Layout: MainLayout,
    Component: ActionStackDemo
  },
  {
    path: demoPath.cgButton,
    Layout: MainLayout,
    Component: CGButtonDemo
  },
  ...authRoutes,
  ...errorRoutes
];

export default function useRouteElements(resources: IResourceFullAccessDetail[], resourcePermissionLoading: boolean) {
  const permissionResource = usePermissionNew(
    [...routesV2, ...commonRoutes].map((x) => x.path),
    resources
  );

  const hasPermission = (path: string, permission: PermissionEn) => {
    const similarResource = permissionResource?.filter((x) => path?.includes(x?.path as string));
    const mostSimilarPath = similarResource?.reduce((prevPath, currPath) => {
      return (currPath?.path?.length || 0) > (prevPath?.path?.length || 0) ? currPath : prevPath;
    }, similarResource[0]);
    if (mostSimilarPath) {
      return mostSimilarPath?.permissions?.includes(permission);
    }
    return false;
  };

  const routeElements = useRoutes(
    [...routesV2, ...commonRoutes].map(
      ({
        path,
        redirect,
        Layout,
        SubLayout,
        Component,
        permission,
        hasSidebar,
        hasSubSidebar,
        isDisableFooter,
        isHideDetailLayout,
        hasSubHeader,
        ticketCategoryCode
      }) => {
        // const innerPaths = isUsePathV2 ? pathsV2 : paths;
        const resComponent = redirect ? (
          <Navigate to={redirect} />
        ) : (
          <Component ticketCategoryCode={ticketCategoryCode} />
        );

        if (!SubLayout && Layout) {
          return {
            path,
            element: (
              <Layout isDisableFooter={isDisableFooter} hasSidebar={hasSidebar}>
                <LoadingCustom isLoading={!!resourcePermissionLoading || !resources} message='Đang tải tài nguyên...' />
                {!resourcePermissionLoading && !!resources ? (
                  <Suspense>
                    {
                      // checkPath && !paths?.includes(checkPath) ? (
                      //   <NotFound />
                      // ) :
                      permission && !hasPermission(path, permission) ? <Forbidden /> : resComponent
                    }
                  </Suspense>
                ) : (
                  <></>
                )}
              </Layout>
            )
          };
        } else if (SubLayout && Layout) {
          return {
            path,
            element: (
              <Layout isDisableFooter={isDisableFooter}>
                <Suspense>
                  <SubLayout
                    hasSidebar={hasSidebar}
                    hasSubHeader={hasSubHeader}
                    hasSubSidebar={hasSubSidebar}
                    isHideDetailLayout={isHideDetailLayout}
                  >
                    <Suspense>
                      {
                        // checkPath && !paths?.includes(checkPath) ? (
                        //   <NotFound />
                        // ) :
                        permission && !hasPermission(path, permission) ? <Forbidden /> : resComponent
                      }
                      {/* {permission ? (
                        hasPermission(path, permission) ? (
                          resComponent
                        ) : (
                          <Forbidden />
                        )
                      ) : !checkPath || paths.length === 0 || paths?.includes(checkPath) ? (
                        resComponent
                      ) : (
                        <NotFound />
                      )} */}
                    </Suspense>
                  </SubLayout>
                </Suspense>
              </Layout>
            )
          };
        } else
          return {
            path,
            element: resComponent
          };
      }
    )
  );

  return routeElements;
}
